import styled, { css } from 'styled-components';
import { Theme } from '@gloat/types';
import { lighten, colors } from '../../style';

// components
import BaseCard, { BaseCardProps } from './base-card';

// types

const variants = {
  'dark-blue': () => ({
    backgroundColor: colors.darkBlue,
    activeBackgroundColor: colors.selectedBlue,
    activeBackgroundColorLight: lighten(0.05, colors.selectedBlue),
    stripeColor: colors.white,
    color: colors.white,
    css: '',
  }),
  'gray100-action': ({ actionColor, actionLight }: Theme) => ({
    backgroundColor: colors.gray100,
    activeBackgroundColor: actionLight,
    activeBackgroundColorLight: actionLight,
    stripeColor: actionColor,
    css: '',
  }),
  'gray100-action-clean': ({ actionLight }: Theme) => ({
    backgroundColor: colors.gray100,
    activeBackgroundColor: colors.gray100,
    activeBackgroundColorLight: actionLight,
    stripeColor: colors.gray100,
    css: '',
  }),
};

const sizes = {
  auto: '',
  md: css`
    width: 96px;
    height: 96px;
  `,
};

const SideTabCard = styled(BaseCard).withConfig({
  shouldForwardProp: prop => !['variant', 'size'].includes(prop),
})<BaseCardProps & { variant: keyof typeof variants; size?: keyof typeof sizes }>`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
  position: relative;
  overflow: hidden;

  ${props => {
    const {
      backgroundColor,
      activeBackgroundColor,
      activeBackgroundColorLight,
      stripeColor,
      css: customVariantCss,
    } = variants[props.variant](props.theme);
    return css`
      background: ${backgroundColor};
      color: ${colors.white};

      ${customVariantCss};

      &:hover {
        background: ${activeBackgroundColor};
      }

      &.active {
        background: ${activeBackgroundColor};

        &:focus-visible {
          border: 1px solid white;
        }

        &:before {
          content: '';
          height: 100%;
          width: 4px;
          background: ${stripeColor};
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      &:focus-visible,
      &:active,
      &.active:active {
        background: ${activeBackgroundColorLight};
      }

      &.disabled,
      &[disabled] {
        color: ${colors.gray600};
        cursor: not-allowed;
        background: ${colors.gray400};
      }
    `;
  }};

  ${props => sizes[props.size || 'auto']};

  &:not([disabled]),
  &:not(.disabled) {
    cursor: pointer;
  }
`;

export default SideTabCard;
